export function mapTurnstileLanguage(lang) {
  if (!lang) return undefined;
  const lower = String(lang).toLowerCase();
  // Chinese: choose Simplified vs Traditional
  if (lower.startsWith('zh')) {
    if (lower.includes('tw') || lower.includes('hk') || lower.includes('hant')) return 'zh-TW';
    return 'zh-CN';
  }
  // Portuguese regional
  if (lower.startsWith('pt')) {
    if (lower.includes('br')) return 'pt-BR';
    return 'pt-PT';
  }
  // Generic: two-letter code
  return lower.slice(0, 2);
}

























